import {
  DITypes,
  EDateFormat,
  IUserProfile,
  LocalStorageKeys
} from "@/core/@types/types";
import { IMessageBuilderSlackStrategy } from "./IMessageBuilderStrategy";
import { inject, injectable } from "inversify";
import { type IStorage } from "@/core/plugins/storage/Storage";
import { type IF360Date } from "@/core/plugins/date/F360Date";
import "reflect-metadata";

@injectable()
export default class SlackMessageBuilderStrategy
  implements IMessageBuilderSlackStrategy
{
  @inject(DITypes.STORAGE) storage!: IStorage;
  @inject(DITypes.DATE) private libDate!: IF360Date;

  getUser() {
    const storage = this.storage.get<IUserProfile>(
      LocalStorageKeys.UserProfile
    );

    return storage?.Email;
  }

  getCLI() {
    const storage = this.storage.get<IUserProfile>(
      LocalStorageKeys.UserProfile
    );

    return storage?.Grupo;
  }

  buildMessage(acao: string): string {
    const date = this.libDate.now();
    const diaAtual = this.libDate.format(date, EDateFormat.day);
    const hora = this.libDate.format(date, "HH:mm");

    return `\nAcao: ${acao}, \nCLI: ${this.getCLI()}, \nData: ${diaAtual}, \nHorario: ${hora}, \nUsuario: ${this.getUser()}`;
  }
}
